import React from 'react'
import { useTranslation } from 'react-i18next'
import { ConfirmationControl } from 'components/Controls'
import { useCategoryRemove } from 'features/immigrate-category/hooks'
import { ActionIcon } from 'components/Elements'

export const RemoveControl = ({ data, onSuccess }) => {
  const { t } = useTranslation()

  const { loading, onSubmit } = useCategoryRemove()

  const onRemoveConfirm = async () => {
    await onSubmit(data?.id, onSuccess)
  }

  return (
    <>
      <ConfirmationControl
        onConfirm={onRemoveConfirm}
        render={({ onOpen }) => (
          <ActionIcon onClick={onOpen} name={'remove'} disabled={loading} outline={false} />
        )}
      />
    </>
  )
}
